import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import axios from "../../../axios/index";
import HomeNavbar from "../HomeNavbar/HomeNavbar";
import styles from "./Landing.module.css";
import cardStyles from "../CardsSlider/CardsSlider.module.css";
import { Link } from "react-router-dom";
import PriceSeparator from "./../../../hooks/usePriceSeparator";
import FastViewModal from "../FastViewModal/FastViewModal";
import Footer from "../Footer/Footer";
import LandingModal from "./LandingModal.jsx";

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// icons
import phoneIcon from "../../../assets/img/HomePage/phoneIconBlue.svg";

const e2p = (s) => s?.toString()?.replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[d]);

export default function Landing() {
  const [showModal, setShowModal] = useState(false);
  const [filesData, setFilesData] = useState({
    turkeyCards: [],
    cyprusCards: [],
    loading: false,
  });
  const [modalData, setModalData] = useState({
    show: false,
    id: "",
    loading: true,
  });

  useEffect(() => {
    async function fetchData() {
      const [turkeyCards, cyprusCards] = await Promise.all([
        axios.get(
          "Home/GetProducts?EstateType=2&Status=2&EstateRegion=2&Take=10"
        ),
        axios.get(
          "Home/GetProducts?EstateType=2&Status=2&EstateRegion=3&Take=10"
        ),
      ]);
      const turkey = turkeyCards.data.data.data;
      const cyprus = cyprusCards.data.data.data;
      setFilesData((prev) => {
        return { ...prev, turkeyCards: turkey, cyprusCards: cyprus };
      });
    }
    fetchData();
  }, []);

  return (
    <>
      <Helmet>
        <title>خرید خارج از کشور | آذر ملک</title>
        <meta
          name="description"
          content="خرید ملک خارج از کشور با آذر ملک - خرید، فروش، اجاره و رهن ملک"
        />
        <meta
          name="keywords"
          content="اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز, اجاره آپارتمان مسکونی در تبریز, رهن آپارتمان مسکونی در تبریز, اجاره آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, رهن آپارتمان مسکونی در ولیعصر تبریز, اجاره آپارتمان مسکونی در رشدیه  تبریز, رهن آپارتمان مسکونی در رشدیه  تبریز, اجاره آپارتمان مسکونی در زعفرانیه  تبریز, رهن آپارتمان مسکونی در زعفرانیه  تبریز, اجاره آپارتمان مسکونی در مرزداران  تبریز, رهن آپارتمان مسکونی در مرزداران  تبریز"
        />
        <meta content="index , follow" name="robots" />
        <meta
          name="og:title"
          content="خرید ملک خارج از کشور با آذر ملک - خرید، فروش، اجاره و رهن ملک"
        />
        <meta
          name="description"
          content="خرید ملک خارج از کشور با آذر ملک - خرید، فروش، اجاره و رهن ملک"
        />
        <meta
          name="og:description"
          content="خرید ملک خارج از کشور با آذر ملک - خرید، فروش، اجاره و رهن ملک"
        />
        <meta rel="canonical" href="https://azrmelk.com/محاسبه-آنلاین-کمیسیون" />
        <meta content="website" property="og:type" />
        <meta content="https://azrmelk.com" name="twitter:site" />
        <meta content="https://azrmelk.com/محاسبه-آنلاین-کمیسیون" property="og:url" />
      </Helmet>

      <LandingModal
        show={showModal}
        onHide={() => {
          setShowModal(false);
        }}
      />

      <FastViewModal
        show={modalData.show}
        id={modalData.id}
        loading={modalData.loading}
        setModalData={setModalData}
        onHide={() => {
          setModalData((prev) => {
            return { ...prev, show: false };
          });
        }}
        landing={true}
      />

      <style type="text/css">
        {`
        @media only screen and (max-width: 605.98px) {
        .swiper {
            height: auto;
          }
        }

        .swiper-button-prev,
        .swiper-button-next {
          top: 52.5%;
        }

        `}
      </style>

      <div className={styles.bg}>
        <div className="d-flex justify-content-center align-items-start vw-100">
          <div className="w-100 ms-0 p-0">
            <HomeNavbar landing />
            <main
              className="container py-3 px-md-0 px-3 mt-4 text-end"
              dir="rtl"
            >
              <section
                className={`d-flex flex-column align-items-center justify-content-center gap-2 mb-5 px-md-0 px-3 ${styles.bg__blur}`}
              >
                <h1 className={`w-100 ${styles.head__title} px-3`}>
                  خرید ملک در قبرس با آذرملک
                </h1>
                <p className={styles.text}>
                  آذرملک مفتخر است بعد سالها فعالیت حرفه ای در زمینه املاک در
                  کلانشهر تبریز و ارائه خدمات به همشهریان عزیزمان ، اینک از
                  پروژه جدید خود برای اولین بار در ایران رونمایی کند. در این
                  راستا با استعانت از خداوند متعال و تلاشهای مدیریت آذرملک ، با
                  توجه به نیاز مشتریان در خصوص انجام معاملات معتبر در کشورهای
                  دیگر با معتبرترین شرکت سرمایه گذاری غرب آسیا (فنرجی اوغلو) در
                  کشور قبرس به توافق رسیده و نمایندگی این شرکت را اخذ نموده است
                  و به صورت فعال و ویژه در خدمت مشتریان خود همچون گذشته خواهد
                  بود. لازم به ذکر است شرکت فنرجی اوغلی بنام ترین و قوی ترین
                  شرکت قبرس می باشد که علاوه بر قبرس در کشورهای ترکیه و اسپانیا
                  و پرتغال پروژه های فعال ساختمانی معتبری دارند که آذرملک طی
                  قرارداد کاملا دقیق و کارشناسی شده مجری فروش پروژه های این شرکت
                  خواهد بود.
                </p>
                <div className="w-100 px-3">
                  <button
                    className={styles.btn}
                    onClick={() => {
                      setShowModal(true);
                    }}
                  >
                    مشاهده روی نقشه
                  </button>
                </div>
              </section>
              <section className="w-100 d-flex flex-column mt-3">
                <div
                  className={`d-flex flex-column align-items-start justify-content-center gap-2 mb-3 ${styles.bg__blur}`}
                  style={{ width: "300px" }}
                >
                  <h2 className={styles.head__title}>خرید ملک در قبرس</h2>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-1">
                  <Swiper
                    className="mySwiper w-100"
                    dir="ltr"
                    style={{ height: "615px" }}
                    breakpoints={{
                      640: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                      },
                      768: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                      },
                      1024: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                      },
                    }}
                    modules={[Autoplay, Pagination, Navigation]}
                    navigation={true}
                    autoplay={{
                      delay: 6500,
                      disableOnInteraction: false,
                    }}
                    pagination={{
                      clickable: true,
                    }}
                    loop={true}
                  >
                    {filesData.cyprusCards?.map((item) => (
                      <SwiperSlide key={item.id}>
                        <div
                          onClick={() => modalHandler(item.id)}
                          className={`d-flex align-items-center justify-content-center ${cardStyles.fastview_btn}`}
                          dir="rtl"
                        >
                          <span className="ms-1">مشاهده سریع</span>
                          <svg
                            width="24"
                            height="16"
                            viewBox="0 0 24 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M1.01662 7.16448C4.06662 2.79251 8.02127 0.5 11.9831 0.5C16.6362 0.5 20.6443 3.53129 23.0091 7.18363L23.0102 7.18535C23.1667 7.4285 23.2499 7.71155 23.2499 8.0007C23.2499 8.28933 23.167 8.57187 23.0111 8.81473C20.6483 12.5141 16.6661 15.5 11.9831 15.5C7.25032 15.5 3.34483 12.5203 0.987915 8.83171C0.827766 8.58304 0.744702 8.29255 0.749197 7.99677C0.753702 7.70025 0.845999 7.41172 1.01443 7.16763L1.01662 7.16448ZM2.24903 8.01956L2.25111 8.02279C4.42804 11.4304 7.91716 14 11.9831 14C16.0036 14 19.5679 11.4195 21.7474 8.0065L21.7489 8.00426C21.7495 8.00319 21.7499 8.00196 21.7499 8.0007C21.7499 8.00017 21.7498 7.99965 21.7497 7.99914C21.7496 7.9985 21.7493 7.99787 21.749 7.9973C19.5611 4.61915 15.9676 2 11.9831 2C8.63897 2 5.09927 3.93555 2.24903 8.01956ZM11.9991 5C10.3422 5 8.99907 6.34315 8.99907 8C8.99907 9.65685 10.3422 11 11.9991 11C13.6559 11 14.9991 9.65685 14.9991 8C14.9991 6.34315 13.6559 5 11.9991 5ZM7.49907 8C7.49907 5.51472 9.51379 3.5 11.9991 3.5C14.4844 3.5 16.4991 5.51472 16.4991 8C16.4991 10.4853 14.4844 12.5 11.9991 12.5C9.51379 12.5 7.49907 10.4853 7.49907 8Z"
                              fill="#1D1D1D"
                            />
                          </svg>
                        </div>
                        <Link
                          // to={{
                          //   pathname: `/فایل/${item.slug}`,
                          //   state: {
                          //     state: item,
                          //   },
                          // }}
                          dir="rtl"
                          className={`d-flex align-items-center flex-column px-2 py-2 mt-3 mb-4 text ${styles.slider_card_container}`}
                        >
                          <div className="w-100 position-relative mb-3 px-2">
                            <img
                              className={cardStyles.card_img}
                              loading="lazy"
                              src={`https://backdev.azrmelk.com${item.imageUrl}`}
                              alt={item.title}
                            />
                          </div>
                          <div className="w-100 text-end px-2 mb-1">
                            <Link
                              // to={{
                              //   pathname: `/فایل/${item.slug}`,
                              //   state: {
                              //     state: item,
                              //   },
                              // }}
                            >
                              <h3 className={`d-block ${cardStyles.card_title}`}>{e2p(item.title)}</h3>
                            </Link>
                          </div>

                          <div className="w-100 d-flex flex-column justify-content-center align-items-center align-items-md-start px-2 flex-wrap">
                            <h4 className={cardStyles.card_text2}>شروع قیمت</h4>
                            <div
                              className={`${styles.progress__bar} w-100 position-relative d-flex flex-column align-items-center my-3`}
                            >
                              <span className="position-absolute h-100"></span>
                              <div className="w-100 d-flex justify-content-between align-items-center mt-3">
                                <h4 className={styles.card_text2}>
                                  از {e2p(PriceSeparator(item.priceFrom))}{" "}
                                  {item.estatePriceType == "1"
                                    ? "تومان"
                                    : item.estatePriceType == "2"
                                    ? "لیر"
                                    : item.estatePriceType == "3"
                                    ? "دلار"
                                    : item.estatePriceType == "4" && "پوند"}
                                </h4>
                                <h4 className={styles.card_text2}>تا</h4>
                                <h4 className={styles.card_text2}>
                                  {e2p(PriceSeparator(item.toPrice))}{" "}
                                  {item.estatePriceType == "1"
                                    ? "تومان"
                                    : item.estatePriceType == "2"
                                    ? "لیر"
                                    : item.estatePriceType == "3"
                                    ? "دلار"
                                    : item.estatePriceType == "4" && "پوند"}
                                </h4>
                              </div>
                            </div>
                          </div>
                          {/* <hr /> */}
                          <div
                            className={`${cardStyles.card_hr} ${styles.hr}`}
                          ></div>

                          <button
                            className={`w-100 d-flex align-items-center justify-content-center mt-3 ${styles.bottom__btn}`}
                          >
                            <img src={phoneIcon} alt="icon" />
                            <div className={cardStyles.text_primary}>
                              تماس با مشاور
                            </div>
                          </button>
                        </Link>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </section>
              <section className="w-100 d-flex flex-column mt-3">
                <div
                  className={`d-flex flex-column align-items-start justify-content-center gap-2 mb-3 ${styles.bg__blur}`}
                  style={{ width: "300px" }}
                >
                  <h2 className={styles.head__title}>خرید ملک در ترکیه</h2>
                </div>
                <div className="d-flex align-items-center justify-content-between mt-1">
                  <Swiper
                    className="mySwiper w-100"
                    dir="ltr"
                    style={{ height: "615px" }}
                    breakpoints={{
                      640: {
                        slidesPerView: 1,
                        spaceBetween: 0,
                      },
                      768: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                      },
                      1024: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                      },
                    }}
                    modules={[Autoplay, Pagination, Navigation]}
                    navigation={true}
                    autoplay={{
                      delay: 7000,
                      disableOnInteraction: false,
                    }}
                    pagination={{
                      clickable: true,
                    }}
                    loop={true}
                  >
                    {filesData.turkeyCards?.map((item) => (
                      <SwiperSlide key={item.id}>
                        <div
                          onClick={() => modalHandler(item.id)}
                          className={`d-flex align-items-center justify-content-center ${cardStyles.fastview_btn}`}
                          dir="rtl"
                        >
                          <span className="ms-1">مشاهده سریع</span>
                          <svg
                            width="24"
                            height="16"
                            viewBox="0 0 24 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M1.01662 7.16448C4.06662 2.79251 8.02127 0.5 11.9831 0.5C16.6362 0.5 20.6443 3.53129 23.0091 7.18363L23.0102 7.18535C23.1667 7.4285 23.2499 7.71155 23.2499 8.0007C23.2499 8.28933 23.167 8.57187 23.0111 8.81473C20.6483 12.5141 16.6661 15.5 11.9831 15.5C7.25032 15.5 3.34483 12.5203 0.987915 8.83171C0.827766 8.58304 0.744702 8.29255 0.749197 7.99677C0.753702 7.70025 0.845999 7.41172 1.01443 7.16763L1.01662 7.16448ZM2.24903 8.01956L2.25111 8.02279C4.42804 11.4304 7.91716 14 11.9831 14C16.0036 14 19.5679 11.4195 21.7474 8.0065L21.7489 8.00426C21.7495 8.00319 21.7499 8.00196 21.7499 8.0007C21.7499 8.00017 21.7498 7.99965 21.7497 7.99914C21.7496 7.9985 21.7493 7.99787 21.749 7.9973C19.5611 4.61915 15.9676 2 11.9831 2C8.63897 2 5.09927 3.93555 2.24903 8.01956ZM11.9991 5C10.3422 5 8.99907 6.34315 8.99907 8C8.99907 9.65685 10.3422 11 11.9991 11C13.6559 11 14.9991 9.65685 14.9991 8C14.9991 6.34315 13.6559 5 11.9991 5ZM7.49907 8C7.49907 5.51472 9.51379 3.5 11.9991 3.5C14.4844 3.5 16.4991 5.51472 16.4991 8C16.4991 10.4853 14.4844 12.5 11.9991 12.5C9.51379 12.5 7.49907 10.4853 7.49907 8Z"
                              fill="#1D1D1D"
                            />
                          </svg>
                        </div>
                        <Link
                          // to={{
                          //   pathname: `/فایل/${item.slug}`,
                          //   state: {
                          //     state: item,
                          //   },
                          // }}
                          dir="rtl"
                          className={`d-flex align-items-center flex-column px-2 py-2 mt-3 mb-4 text ${styles.slider_card_container}`}
                        >
                          <div className="w-100 position-relative mb-3 px-2">
                            <img
                              className={cardStyles.card_img}
                              loading="lazy"
                              src={`https://backdev.azrmelk.com${item.imageUrl}`}
                              alt={item.title}
                            />
                          </div>
                          <div className="w-100 text-end px-2 mb-1">
                            <Link
                              // to={{
                              //   pathname: `/فایل/${item.slug}`,
                              //   state: {
                              //     state: item,
                              //   },
                              // }}
                            >
                              <h3 className={`d-block ${cardStyles.card_title}`}>{e2p(item.title)}</h3>
                            </Link>
                          </div>

                          <div className="w-100 d-flex flex-column justify-content-center align-items-center align-items-md-start px-2 flex-wrap">
                            <h4 className={cardStyles.card_text2}>شروع قیمت</h4>
                            <div
                              className={`${styles.progress__bar} w-100 position-relative d-flex flex-column align-items-center my-3`}
                            >
                              <span className="position-absolute h-100"></span>
                              <div className="w-100 d-flex justify-content-between align-items-center mt-3">
                                <h4 className={styles.card_text2}>
                                  از {e2p(PriceSeparator(item.priceFrom))}{" "}
                                  {item.estatePriceType == "1"
                                    ? "تومان"
                                    : item.estatePriceType == "2"
                                    ? "لیر"
                                    : item.estatePriceType == "3"
                                    ? "دلار"
                                    : item.estatePriceType == "4" && "پوند"}
                                </h4>
                                <h4 className={styles.card_text2}>تا</h4>
                                <h4 className={styles.card_text2}>
                                  {e2p(PriceSeparator(item.toPrice))}{" "}
                                  {item.estatePriceType == "1"
                                    ? "تومان"
                                    : item.estatePriceType == "2"
                                    ? "لیر"
                                    : item.estatePriceType == "3"
                                    ? "دلار"
                                    : item.estatePriceType == "4" && "پوند"}
                                </h4>
                              </div>
                            </div>
                          </div>
                          {/* <hr /> */}
                          <div
                            className={`${cardStyles.card_hr} ${styles.hr}`}
                          ></div>

                          <button
                            className={`w-100 d-flex align-items-center justify-content-center mt-3 ${styles.bottom__btn}`}
                          >
                            <img src={phoneIcon} alt="icon" />
                            <div className={cardStyles.text_primary}>
                              تماس با مشاور
                            </div>
                          </button>
                        </Link>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
              </section>
            </main>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );

  function modalHandler(id) {
    setModalData((prev) => {
      return { ...prev, id: id, show: true };
    });
  }
}
